import Typography from "@mui/material/Typography";
import { useEffect } from "react";
import ModalIntroImage from "../../assets/intro-modal-image.svg";
import { BaseIntroModal } from "../../components/BaseIntroModal";
import { useModal } from "../../hooks/UseModal/useModal";

export const FirstVisitModalContainer = () => {
  const { openModal, closeModal } = useModal();

  const modalConfig = {
    title: "Welcome to myTW!",
    contentText: (
      <>
        <Typography color="grey.800" sx={{ marginBottom: "24px" }}>
          <b>myTW</b> is (increasingly) becoming your personalized{" "}
          <b>one-stop shop</b>, unifying your profile and self-service options.
        </Typography>
        <Typography color="grey.800" sx={{ marginBottom: "24px" }}>
          Our vision is that TWers enjoy <b>services that just work</b> — to
          free you up from having to navigate TW's complexity and fragmentation.
        </Typography>
        <Typography color="grey.800" sx={{ marginBottom: "24px" }}>
          Share your feedback and stay tuned. It is <b>just the beginning!</b>
        </Typography>
      </>
    ),
    submitButtonLabel: "Got it!",
    cancelButtonLabel: "",
    onSubmit: () => closeModal,
    imageSrc: ModalIntroImage,
    imageAlt: "illustration of a person moving some components on a big screen",
    imageStyle: {
      width: "340px",
      height: "214px",
      alignSelf: "center",
    },
  };

  const markAsVisitedInLocalStorage = () => {
    const newUserSettings = {
      previouslyVisited: true,
    };
    localStorage.setItem("user-settings", JSON.stringify(newUserSettings));
  };

  const openModalAndSetUserAsFirstTimeVisiting = () => {
    openModal(modalConfig);
    markAsVisitedInLocalStorage();
  };

  const isFirstVisit = (): Boolean => {
    const userSettingsFromLocalStorage = localStorage.getItem("user-settings");

    if (userSettingsFromLocalStorage) {
      const userSettings = JSON.parse(userSettingsFromLocalStorage);

      return !userSettings.previouslyVisited;
    }

    return true;
  };

  const initModalEventListener = () => {
    document.addEventListener("@my-intro-modal:open", () =>
      openModal(modalConfig)
    );
  };

  useEffect(() => {
    if (isFirstVisit()) {
      openModalAndSetUserAsFirstTimeVisiting();
    }

    initModalEventListener();
  }, []);

  return <BaseIntroModal />;
};
